import {
  Div,
  Icon,
  Img,
  lightTheme,
  Provider,
  renderProviderIcon,
  X,
} from '@vgrubs/components';

export const SelectedOrderProvider = ({
  provider,
  handleDelete,
}: {
  provider: Provider;
  handleDelete: () => void;
}) => {
  return (
    <Div $flex $gap="2px">
      <Img
        alt=""
        src={renderProviderIcon(provider)}
        $width="32px"
        $widthSM="32px"
      />
      <Icon $size="12" display="block" $pointer onClick={handleDelete}>
        <X fill={lightTheme.lightGray} />
      </Icon>
    </Div>
  );
};
